import React from 'react';
import { useHistory } from 'react-router-dom';
import { ADMIN_ROUTES, ROUTES } from '../../../util/vars';
import { useI18n } from '@whizz/react-i18n';
import { Button } from '../../../components';

const AdminListTabs = ({ active }: { active: 'schools' | 'organizations' }) => {
  const history = useHistory();
  const { translate: t } = useI18n();

  return (
    <div className={'flex gap-4 mb-6'}>
      <Button
        color={'primary'}
        isOutline={active !== 'schools'}
        onClick={() => history.push(`${ROUTES.superAdmin}${ADMIN_ROUTES.schools}`)}
      >
        {t('pages.ADMIN.SCHOOLS.TITLE')}
      </Button>
      <Button
        color={'primary'}
        isOutline={active !== 'organizations'}
        onClick={() => history.push(`${ROUTES.superAdmin}${ADMIN_ROUTES.organizations}`)}
      >
        {t('pages.ADMIN.ORGANIZATIONS.TITLE')}
      </Button>
    </div>
  );
};

export { AdminListTabs };
